import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieObject } from './cookieobject';
import { CookieInputs } from './cookieinputs';
import { HttpClient } from '@angular/common/http';
import { CookieConfig } from './cookie-config/cookie-config';
import { CookieTranslationConfig } from './cookie-translation-config';

@Component({
    selector: 'app-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.scss']
})
export class CookieComponent implements OnInit {
    closeCookieText() {
        this.isCookieTextopened = false;
    }
    openCookieText() {
        this.isCookieTextopened = true;
    }

    acceptGoogleAnalytics = false;

    acceptGoogleAdsText = '';

    acceptGoogleAnalyticsText = '';

    acceptGoogleAds = false;

    acceptSettings = false;

    selectedAlign: 'start' | 'center' | 'end';

    @Input() hasGoogleAds = false;

    @Input() hasGoogleAnalytics = false;

    @Input() hasAnyOtherSettings = false;

    @Input() privacyPolicyUrl = '';

    dataLayer = window.dataLayer || [];


    isFirstCookieWindowDisplayed = true;
    isCookieTextopened = false;

    cookieTranslationConfig: CookieTranslationConfig = {};

    USER_CONSENT_KEY = 'user_consent';

    COOKIE_CONSENT_KEY = 'cookie_consent';

    constructor(private _http: HttpClient, private _dialog: MatDialog, private dialogRef: MatDialogRef<CookieComponent>, @Inject(MAT_DIALOG_DATA) public _cookieInputs: CookieInputs, private _cookieConfig: CookieConfig) {
        this.selectedAlign = 'end';
        dialogRef.disableClose = true;
        this.hasGoogleAds = _cookieInputs.hasGoogleAds!;
        this.hasGoogleAnalytics = _cookieInputs.hasGoogleAnalytics!;
        this.hasAnyOtherSettings = _cookieInputs.hasAnyOtherSettings!;

    }
    ngOnInit(): void {
        this._http.get<CookieTranslationConfig>(this._cookieConfig.url).subscribe((cookieconfig) => {
            this.cookieTranslationConfig = cookieconfig as CookieTranslationConfig;
        })
    }

    closeDialog() {
        this._dialog.closeAll();
    }

    changeCookieDisplayedWindow() {
        this.isFirstCookieWindowDisplayed = !this.isFirstCookieWindowDisplayed;
    }

    acceptWebsiteCookies() {
        if (this.hasGoogleAds) {
            this.acceptGoogleAds = false;
        }
        if (this.hasGoogleAnalytics) {
            this.acceptGoogleAnalytics = false;
        }
        this.addTextToAcceptGoogle();
        const cookieObject: CookieObject = {
            googleAdsGtagVariable: this.acceptGoogleAdsText,
            googleAnalyticsGtagVariable: this.acceptGoogleAnalyticsText
        }
        localStorage.setItem(this.COOKIE_CONSENT_KEY, JSON.stringify(cookieObject));
        localStorage.setItem(this.USER_CONSENT_KEY, JSON.stringify(false));
        localStorage.setItem("websiteCookieAccepted", JSON.stringify(true));
        this._dialog.closeAll();
        window.location.reload();
    }

    rejectAll() {
        this.addTextToAcceptGoogle();
        const cookieObject: CookieObject = {
            googleAdsGtagVariable: this.acceptGoogleAdsText,
            googleAnalyticsGtagVariable: this.acceptGoogleAnalyticsText
        }

        localStorage.setItem(this.COOKIE_CONSENT_KEY, JSON.stringify(cookieObject));
        localStorage.setItem(this.USER_CONSENT_KEY, JSON.stringify(false));
        localStorage.setItem("websiteCookieAccepted", JSON.stringify(false));
        this._dialog.closeAll();
    }

    acceptAll() {
        if (this.hasGoogleAds) {
            this.acceptGoogleAds = true;
        }
        if (this.hasGoogleAnalytics) {
            this.acceptGoogleAnalytics = true;
        }
        this.addTextToAcceptGoogle();
        const cookieObject: CookieObject = {
            googleAdsGtagVariable: this.acceptGoogleAdsText,
            googleAnalyticsGtagVariable: this.acceptGoogleAnalyticsText
        }

        localStorage.setItem(this.COOKIE_CONSENT_KEY, JSON.stringify(cookieObject));
        localStorage.setItem(this.USER_CONSENT_KEY, JSON.stringify(true));
        localStorage.setItem("websiteCookieAccepted", JSON.stringify(true));
        this._dialog.closeAll();
        window.location.reload();
    }

    onChangeAnalytics() {
        this.acceptGoogleAnalytics = !this.acceptGoogleAnalytics;
    }

    onChangeGoogleAds() {
        this.acceptGoogleAds = !this.acceptGoogleAds;
    }

    addTextToAcceptGoogle() {
        if (this.acceptGoogleAnalytics === false) {
            this.acceptGoogleAnalyticsText = 'denied';
        }
        else {
            this.acceptGoogleAnalyticsText = 'granted';
        }
        if (this.acceptGoogleAds === false) {
            this.acceptGoogleAdsText = 'denied';
        }
        else {
            this.acceptGoogleAdsText = 'granted';
        }
    }

    savePreferences() {
        this.addTextToAcceptGoogle();
        const cookieObject: CookieObject = {
            googleAdsGtagVariable: this.acceptGoogleAdsText,
            googleAnalyticsGtagVariable: this.acceptGoogleAnalyticsText
        }
        localStorage.setItem(this.COOKIE_CONSENT_KEY, JSON.stringify(cookieObject));
        localStorage.setItem(this.USER_CONSENT_KEY, JSON.stringify(true));
        localStorage.setItem("websiteCookieAccepted", JSON.stringify(true));
        this._dialog.closeAll();
        window.location.reload();
    }

    onChangeSettings() {
        this.acceptSettings = !this.acceptSettings;
    }

}
